import emailjs from '@emailjs/browser';

const SERVICE_ID = "service_ob12knk";
const PATIENT_TEMPLATE_ID = "template_x60go5j";
const DOCTOR_TEMPLATE_ID = "template_xzrb0hp";
const PUBLIC_KEY = "J95HOtcaJOAt0rzmp";

// Patient confirmation email
export const sendConfirmationEmail = async (formData) => {
  try {
    await emailjs.send(SERVICE_ID, PATIENT_TEMPLATE_ID, {
      patient_name: formData.name,
      patient_email: formData.email,
      date: formData.date,
      time: formData.time,
      symptoms: formData.symptoms,
    }, PUBLIC_KEY);
    return { success: true };
  } catch (err) {
    console.error('Patient email error:', err);
    return { success: false };
  }
};

// Doctor notification email
export const sendDoctorNotification = async (formData) => {
  try {
    await emailjs.send(SERVICE_ID, DOCTOR_TEMPLATE_ID, {
      patient_name: formData.name,
      patient_phone: formData.phone,
      patient_email: formData.email,
      patient_age: formData.age,
      date: formData.date,
      time: formData.time,
      symptoms: formData.symptoms,
    }, PUBLIC_KEY);
    return { success: true };
  } catch (err) {
    console.error('Doctor email error:', err);
    return { success: false };
  }
};
